import { KPICalcType, ChartType } from '../../types';
import { Gauge, BarChart2, PieChart as PieIcon, LineChart as LineIcon, Activity, Layers, TrendingUp, ScatterChart as ScatterIcon, TableProperties } from 'lucide-react';

export const MARKER_COLORS = ['green', 'orange', 'blue', 'red', 'violet', 'grey', 'gold', 'black'];

export function deg2rad(deg: number) { return deg * (Math.PI / 180); }

export function getDistanceKm(lat1: number, lon1: number, lat2: number, lon2: number) {
  const R = 6371;
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export const MAP_LAYERS = [
  { id: 'standard', name: 'Padrão', url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' },
  { id: 'satellite', name: 'Satélite', url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}' },
  { id: 'dark', name: 'Escuro', url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png' }
];

export const CHART_COLORS = ['#2563eb', '#f97316', '#10b981', '#ef4444', '#8b5cf6', '#06b6d4', '#f59e0b', '#ec4899'];

export const CALC_LABELS: Record<KPICalcType, string> = {
  sum: 'Soma',
  avg: 'Média',
  count: 'Contagem',
  count_unique: 'Contar Únicos',
  delta: 'Variação (máx − mín)',
  max: 'Máximo',
  min: 'Mínimo',
  mode: 'Mais frequente',
  median: 'Mediana',
};

export const VIZ_META: Record<ChartType, { label: string; icon: any; desc: string }> = {
  kpi: { label: 'Indicador', icon: Gauge, desc: 'Número grande de destaque' },
  bar: { label: 'Barras', icon: BarChart2, desc: 'Comparar categorias' },
  pie: { label: 'Pizza', icon: PieIcon, desc: 'Proporção do total' },
  line: { label: 'Linha', icon: LineIcon, desc: 'Tendência ao longo do tempo' },
  area: { label: 'Área', icon: Activity, desc: 'Volume acumulado' },
  scatter: { label: 'Dispersão', icon: ScatterIcon, desc: 'Correlação entre pontos' },
  composed: { label: 'Combinado', icon: TrendingUp, desc: 'Barras + linha juntos' },
  area3d: { label: 'Área 3D', icon: Layers, desc: 'Efeito visual de área em camadas' },
  table: { label: 'Tabela Dinâmica', icon: TableProperties, desc: 'Cruzamento de Eixo X e Colunas' },
};
